import { format, isToday, addHours } from 'date-fns'

const urlApiDev = process.env.API_BASE_URL_DEV
const urlApiProd = process.env.API_BASE_URL
const keyDev = process.env.KEY_AGENDAMENTOS_DEV
const keyProd = process.env.KEY_AGENDAMENTOS_PROD

const isDev = [
  'localhost',
  'homologacao.senhadigitalplus.com.br',
  'leonardo.senhadigitalplus.com.br',
  'link.senhadigitalplus.com.br',
].includes(window.location.hostname)

const urlApi = isDev ? urlApiDev : urlApiProd
const key = isDev ? keyDev : keyProd
const headers = {
  'x-api-key': `${key}`,
  'content-type': 'application/json',
}
export const state = () => ({
  slotsDay: '',
})

export const getters = {
  allSlotsDay: (state) => {
    const today = new Date()
    const hrsAtraso = 2
    const todayWithDelay = addHours(today, hrsAtraso)

    return state.slotsDay
      .filter((slot) => {
        const slotDateTime = new Date(slot.horario)

        if (isToday(slotDateTime)) {
          return slotDateTime >= todayWithDelay
        }
        return true
      })
      .map((slot) => {
        const slotDateTime = new Date(slot.horario)
        const formattedDateTime = format(slotDateTime, 'HH:mm')

        return {
          ...slot,
          slot: formattedDateTime,
        }
      })
  },
}

export const mutations = {
  SET_SLOTS: (state, payload) => (state.slotsDay = payload),
}

export const actions = {
  async listSlotsDay({ commit }, payload) {
    const { data } = await this.$axios.post(
      `${urlApi}/agendamentos-open/v1/listSlotsDay`,
      payload,
      {
        headers,
      }
    )
    commit('SET_SLOTS', data)
  },
}
